import { render, staticRenderFns } from "./NotificationBar.vue?vue&type=template&id=fe3c2d3a&scoped=true&"
import script from "./NotificationBar.vue?vue&type=script&lang=js&"
export * from "./NotificationBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../registration-vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe3c2d3a",
  null
  
)

export default component.exports